import { useContext } from 'react';
import { CatalogContext } from 'Catalog/Catalog.context';
import { Helmet } from 'react-helmet-async';
import head__setTitle from 'uitils/head__setTitle';

export default function Head() {
  const { title, lang, pageNum } = useContext(CatalogContext);
  return (
    <Helmet>
      <title>{head__setTitle(title, lang)}</title>

      {/* Fonts */}
      <link
        rel='preconnect'
        href='https://fonts.googleapis.com'
      />
      <link
        rel='preconnect'
        href='https://fonts.gstatic.com'
        crossorigin
      />
      <link
        href='https://fonts.googleapis.com/css2?family=Roboto:wght@200;300;400;500;600;700;800;900&family=Noto+Sans+SC:wght@200;300;400;500;600;700;800;900&display=swap'
        rel='stylesheet'
      />
    </Helmet>
  );
}
